// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"cdec8ce6","587":"50b3ad9f","752":"8fcd7ead","765":"dbc84481"}[chunkId] + ".chunk.css";
};